import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { LocalStorageService } from '@modules/core/services';
import { LocalStorageKeysEnum } from '@modules/core/enums';
import { CookiesAllowedActions } from './cookies-allowed.actions';

@Injectable()
export class CookiesAllowedEffects {
  constructor(private actions$: Actions, private store: Store, private localStorageService: LocalStorageService) {}

  loadCookies$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CookiesAllowedActions.load),
      map((): boolean[] => {
        const isAllowedCookies: boolean = this.localStorageService.getData<boolean>(
          LocalStorageKeysEnum.cookiesAllowed
        );
        const isCookiesPolicyModalVisible: boolean = isAllowedCookies === null;
        return [isAllowedCookies, isCookiesPolicyModalVisible];
      }),
      switchMap(([isAllowedCookies, isCookiesPolicyModalVisible]: boolean[]) => [
        CookiesAllowedActions.setCurrentState({ isAllowedCookies }),
        CookiesAllowedActions.setCurrentStateModal({ isCookiesPolicyModalVisible }),
      ])
    );
  });

  updateCookiesAllowed$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CookiesAllowedActions.updateState),
      map(({ isAllowedCookies }): boolean => {
        this.localStorageService.setData(LocalStorageKeysEnum.cookiesAllowed, isAllowedCookies);
        return isAllowedCookies;
      }),
      switchMap((isAllowedCookies: boolean) => [
        CookiesAllowedActions.setCurrentState({ isAllowedCookies }),
        CookiesAllowedActions.setCurrentStateModal({ isCookiesPolicyModalVisible: false }),
      ])
    );
  });
}
